import React, { useState } from "react";
import Magnifier from "./components/icons/Magnifier";
import { getLabelForValue } from "./utilities";
import "bootstrap-icons/font/bootstrap-icons.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
export function NewsApp({ publicFiles, types, extensions }) {
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedExtensions, setSelectedExtenstions] = useState([]);
    const filtered = publicFiles.filter((file) => {
        let condition = file.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
            file.display_name.toLowerCase().includes(searchQuery.toLowerCase());
        if (selectedTypes.length > 0) {
            condition = condition && selectedTypes.includes(file.file_type);
        }
        if (selectedExtensions.length > 0) {
            condition = condition && selectedExtensions.includes(file.file_extension);
        }
        return condition;
    });
    return (React.createElement("div", { className: "news" },
        React.createElement("h1", { className: "fs-4 fw-bold" }, "Aktualno\u015Bci - Dane og\u00F3lnodost\u0119pne"),
        React.createElement("p", null, "Naj\u015Bwie\u017Csze publiczne zestawy danych. Po dodaniu przez u\u017Cytkownik\u00F3w, dane automatycznie pojawi\u0105 si\u0119 tutaj jako aktualno\u015Bci."),
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "cards_and_search" },
                React.createElement("div", { className: "search-wrapper" },
                    React.createElement("input", { className: "form-control mr-sm-2", name: "query", type: "search", placeholder: "Wyszukaj po nazwie lub opisie...", "aria-label": "Szukaj", value: searchQuery, onChange: (event) => setSearchQuery(event.target.value) }),
                    React.createElement(Magnifier, null)),
                filtered.length == 0 || publicFiles.length == 0 ? (React.createElement("div", { className: "alert alert-info mt-3", role: "alert" },
                    React.createElement("i", { className: "bi bi-info-circle-fill me-2" }),
                    publicFiles.length == 0
                        ? "Brak publicznie dostępnych danych."
                        : "Brak danych spełniających kryteria")) : (React.createElement("div", { className: "container news-cards-container" }, filtered.map(({ display_name, description, owner__username, file_type, file_url, added, }) => (React.createElement("div", { className: "card" },
                    React.createElement("div", { className: "card-body d-flex flex-column" },
                        React.createElement("h5", { className: "card-title" }, display_name),
                        React.createElement("p", { className: "card-subtitle mb-2 text-muted" },
                            "Dodano: ",
                            added),
                        React.createElement(OverlayTrigger, { placement: "right", overlay: React.createElement(Tooltip, null,
                                React.createElement("h6", { className: "description-tooltip-header" }, "OPIS"),
                                description) },
                            React.createElement("p", { className: "card-text card-description" }, description)),
                        React.createElement("p", { className: "card-subtitle mb-2 text-muted mt-auto" },
                            "Dodane przez: ",
                            owner__username),
                        React.createElement("div", { className: "d-flex justify-content-between" },
                            React.createElement("span", { className: "badge bg-info" }, getLabelForValue(types, file_type)),
                            React.createElement("a", { href: file_url, className: "card-link", download: true },
                                "Pobierz",
                                React.createElement("i", { className: "bi bi-download" })))))))))),
            React.createElement("div", { className: "filtering-wrapper" },
                React.createElement("div", { className: "card filtering" },
                    React.createElement(Filter, { label: "Filtruj po rodzaju danych", options: types, inputName: "types", selectedValues: selectedTypes, setSelectedValues: setSelectedTypes }),
                    React.createElement(Filter, { label: "Filtruj po rozszerzeniu pliku", options: extensions, inputName: "extensions", selectedValues: selectedExtensions, setSelectedValues: setSelectedExtenstions }))))));
}
function Filter({ label, inputName, options, selectedValues, setSelectedValues, }) {
    const [isAllChecked, setIsAllChecked] = useState(false);
    function optionIsChecked(selectedValues, value) {
        return selectedValues.includes(value);
    }
    return (React.createElement("div", { className: "card-body" },
        React.createElement("h2", { className: "fs-5 fw-bold" },
            React.createElement("i", { className: "bi bi-filter" }),
            label),
        React.createElement("div", { className: "form-check mt-3" },
            React.createElement("input", { className: "form-check-input", type: "checkbox", id: "choose-all" + inputName, onChange: () => {
                    if (!isAllChecked) {
                        setSelectedValues(options.map((o) => o.value));
                    }
                    else {
                        setSelectedValues([]);
                    }
                    setIsAllChecked((p) => !p);
                }, checked: isAllChecked }),
            React.createElement("label", { className: "form-check-label check-all", htmlFor: "choose-all" + inputName }, !isAllChecked ? "Zaznacz wszystkie" : "Odznacz wszystkie")),
        React.createElement("hr", { className: "mt-3" }),
        React.createElement("div", { className: "card-text" },
            React.createElement("ul", { className: "options" }, options.map((option) => (React.createElement("div", { className: "form-check" },
                React.createElement("input", { className: "form-check-input", type: "checkbox", name: inputName, id: option.label + "checkbox", value: option.value, checked: optionIsChecked(selectedValues, option.value), onChange: (event) => {
                        const previouslySelected = [...selectedValues];
                        let newSelected = previouslySelected.filter((value) => value !== event.target.value);
                        if (event.target.checked) {
                            newSelected.push(event.target.value);
                        }
                        setSelectedValues(newSelected);
                        setIsAllChecked(newSelected.length == options.length);
                    } }),
                React.createElement("label", { className: "form-check-label", htmlFor: option.label + "checkbox" }, option.label))))))));
}
